import React from "react";
import "./TermsAndConditon.scss";
import TAConditionCTA from "./TAConditionCTA";
import { PRIMARY_SOURCE } from "../../../../config/constant";

const TAConditionPuravankaraLandProjects = ({ 
  isPreview, 
  handlePrevious, 
  primarySource, 
  projectName 
}) => {
  return (
      <div
        className={`TermsWrapper ${
          isPreview ? "applicantDetailsCard previewColor" : ""
        }`}
      >
        {isPreview ? (
          <h3 className="titlePersonalHD marginBottom16">Terms & Conditions</h3>
        ) : (
          <div className="titleTerms">Terms & Conditions</div>
        )}
        <ol className="ListNumber">
          <li>
            <b className="liB">1. PAYMENT TERM:</b> The following payment term
            shall be applicable for the successful allotment of the unit
            requested through this application:
          </li>
        </ol>
        <div className="tbResponsive">
          <table>
            <tr>
              <th>Day/Event</th>
              <th>Payment Obligation</th>
              <th>Conditions</th>
            </tr>
            <tr>
              <td>Booking/Advance amount</td>
              <td>500000/- (Rupees five lakh, inclusive of applicable GST)</td>
              <td>Refundable as per Sl no. 7</td>
            </tr>
            <tr>
              <td>Within 10 days from the date of booking</td>
              <td>
                9.5%/10%/15% of the sale consideration as applicable (less
                booking amount)
              </td>
              <td>Refundable as per Sl no. 7</td>
            </tr>
            <tr>
              <td>On Execution of Agreement for sale</td>
              <td>
                In accordance with payment schedule set out in theAgreement of
                sale
              </td>
              <td>As per terms of agreement</td>
            </tr>
          </table>
        </div>

        <ol className="ListNumber">
          <li>
            <b className="liB">
              2. APPLICATION NOT A CONFIRMATION OF ALLOTMENT:{" "}
            </b>
            It is expressly clarified that this application for allotment (the
            “Application") is neither a confirmation of allotment nor implies
            any undertaking by the {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Puravankara Limited"} and/or its subsidiaries/
            affiliates/ associated concerns (the "Promoter") to allot and/or
            reserve and/or block the unit that the applicant(s) have requested
            for, in this Application. If the Application is confirmed, the unit
            preferred and chosen by the applicant(s) (the "Unit") will be
            temporarily blocked and an allotment letter will be issued, subject
            to the explicit conditions set out in paragraph 4 below, failing
            which the company shall be entitled to cancel the allotment and deal
            with the unit in any manner of its choosing.
          </li>
        </ol>

        <ol className="ListNumber">
          <li>
            <b className="liB">3. BASIS OF PROCESSING APPLICATION:</b> This
            ‘Application’ shall be processed basis the fulfillment of the below
            requirements, failing which the ‘Promoter’ shall be entitled to
            reject/cancel the‘Application’
            <ul>
              <li>
                A. All columns in the ‘Application’ are filled completely and
                all pages are duly signed by Applicant(s)
              </li>
              <li>
                B. Applicant(s) shall submit necessary self-attested KYC along
                with this ‘Application’
              </li>
              <li>
                C. Promoter shall process the ‘Application’ in accordance with
                its policies and procedures, including but not limited to
                carrying out the necessary verification of KYC, checks to
                establish the financial credentials and credit score of the
                Applicant(s).
              </li>
              <li>
                D. Availability of the “Unit” at the time of submission of the
                ‘Application’
              </li>
              <li>
                E. Realization of Earnest Money / Booking advance issued towards
                the ‘Unit’
              </li>
            </ul>
          </li>
        </ol>

        <ol className="ListNumber">
          <li>
            <b className="liB conditionOfAllotment">4. CONDITIONS OF ALLOTMENT:</b> The allotment, if
            confirmed pursuant to this Application, is subject to the following
            conditions failing which the flat temporarily reserved for the
            Applicant(S) shall be released and the allotment in favour of
            Applicant(s) shall stand cancelled with immediate effect without the
            need for any further notice to Applicant(s)
            <ul>
              <li>
                (i) The Applicant(s) shall execute and register the agreement to
                sell within 60 (sixty) days from the date of issue of the
                Allotment Letter; and
              </li>
              <li>
                (ii) On execution of the Agreement to Sell, the terms and
                conditions as contained in the Agreement to Sell shall become
                applicable.
              </li>
            </ul>
          </li>
        </ol>

        <ol className="ListNumber">
          <li>
            <b className="liB powerOfAttorney">5. POWERS OF ATTORNEY:</b> In case Applicant(s)
            appoints a power of attorney, a self-attested copy of the power of
            attorney must be submitted along with this Application, failing
            which the Promoter may reject the Application. If the Applicant(s)
            is desirous of appointing a power of attorney for execution and
            registration of the agreement to sell, Promoter may, upon a request
            from Applicant, assist the Applicant in such process, the costs,
            expenses and charges of which shall be borne by the Applicant(s).
          </li>
        </ol>

        <ol className="ListNumber">
          <li>
            <b className="liB">
              6. DEPOSITS, CHARGES, FEES AND OTHER EXPENSES:
            </b> All deposits, fees, expenses, charges or levies including those
            demanded, or incurred, or required to be paid to the relevant
            authorities, bodies, agencies, and/or departments on account of
            developing infrastructure, management of such infrastructure & other
            services shall be borne and paid by the applicant(s) in accordance
            with the terms of the Agreement to Sell.
          </li>
        </ol>

        <ol className="ListNumber seventhTerms">
          <li>
            <b className="liB">7. DEFAULT & CANCELLATION:</b> Any default in
            payments by Applicant(s) to Promoter after issue of the allotment
            letter will be handled in accordance with the terms and conditions
            of the allotment letter or executed agreement to sell as applicable.
            In case of the applicant cancelling or seeking cancellation of the
            booking prior to allotment letter, booking amount paid shall be
            refunded. In case of cancellation of the booking after issuance of
            allotment letter, the cancellation charges shall be as per the table
            provided below:
          </li>
        </ol>
        <div className="tbResponsive">
          <table>
            <tr>
              <th>Sl. No.</th>
              <th>
                If the Letter requesting to cancel the booking is received
              </th>
              <th>Amount to be deducted</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Within 15 days from issuance of the Allotment letter</td>
              <td>Nil</td>
            </tr>
            <tr>
              <td>2</td>
              <td>
                Within 16 to 30 days from issuance of the Allotment letter
              </td>
              <td>1% of the cost of the said unit</td>
            </tr>
            <tr>
              <td>3</td>
              <td>
                Within 31 to 60 days from issuance of the allotment letter
              </td>
              <td>1.5% of the cost of the said unit</td>
            </tr>
            <tr>
              <td>4</td>
              <td>After 61 days from issuance of the allotment letter.</td>
              <td>2% of the cost of the said unit</td>
            </tr>
          </table>
        </div>
        <ol className="ListNumber">
          <li>
            The applicant/s will be solely responsible for timely payment of all
            amounts due, irrespective of whether the payments are made from
            their own funds or by way of housing loan if any availed from a
            bank.
          </li>
        </ol>

        <ol className="ListNumber">
          <li>
            <b className="liB eighthTerms">8. GST:</b> In the event of cancellation of an
            allotment for any reasons whatsoever, all amounts paid on account of
            GST cannot be refunded. The company shall provide certificate to
            applicant stating the amounts paid on account of GST, which
            certificate the applicant may use to directly apply for the refund
            of the GST paid, if permitted by law.
          </li>
        </ol>
        <ol className="ListNumber">
          <li>
            <b className="liB">9. CHANGE MANAGEMENT:</b> In case the applicant/s
            is desirous of changing/substituting the names of
            purchasers/applicants after the execution and registration of the
            agreement to sell, all charges, costs and expenses associated
            therewith, including but not limited to procuring, embossing,
            franking of relevant document and purchase of stamp papers shall be
            borne exclusively by the applicant(s).
          </li>
        </ol>
        <ol className="ListNumber">
          <li>
            <b className="liB">10. MINOR APPLICANT:</b> Wherever a minor is a
            second applicant, all documents shall be signed by the natural
            guardian on behalf of the minor. The natural guardian shall be
            solely responsible for informing the Company once the minor attains
            the age of majority, and at all times prior to the execution of the
            conveyance deed.
          </li>
        </ol>
        <ol className="ListNumber">
          <li>
            <b className="liB">11. TIME IS THE ESSENCE:</b> The Applicant(s)
            undertakes to make payment of any and all amounts due to promoter
            strictly in accordance with the payment schedule stated herein,
            without delay, and in full. The Applicant(s) agrees and acknowledges
            that, subject to confirmation of allotment, time is the essence of
            agreement between Applicant(s) and Promoter, and consequently the
            Applicant(s) obligation to make payments on time and in full is of
            the essence.
          </li>
        </ol>
        <ol className="ListNumber">
          <li>
            <b className="liB">12. GOVERNING LAW:</b> All disputes relating
            to/arising out of or in relation to this application for allotment
            will be subject to the exclusive jurisdiction of the courts located
            in the city where the project is situated.
          </li>
        </ol>
        <ol className="ListNumber">
          <li>
            <b className="liB">13. NRI/PIO APPLICANT(S):</b> Non-resident
            Indians/ Person of Indian Origin shall comply with all statutory
            compliances applicable by laws, rules and regulations prevalent in
            India for purchase of Apartment(s) sold by the Company. The Company
            shall not be liable for any non-compliance on part of the NRI/PIO
            Applicant(s).
          </li>
        </ol>
      <ol className="ListNumber">
          <li>
            <b className="liB">14. Consent to Use of KYC Details:</b> I authorize Puravankara Limited and its group companies to collect and store my Aadhaar and PAN details, including document images, for identity verification and compliance purposes. My information will be kept confidential and used only as per applicable data privacy laws.
          </li>
        </ol>
        {primarySource === PRIMARY_SOURCE?.PurvaPrivilege ? (
          <div className="referralProgramTerms">
            <ol className="ListNumber">
              <li>
                <b className="liB">REFERRAL PROGRAM</b>
              </li>
            </ol>

            <ol className="ListNumber">
              <li>
                1. Purva Privilege is a program offered by {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Puravankara Limited"}. exclusively for home owners in Puravankara Ltd. projects or projects developed by its subsidiary companies.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              2. The applicant is required to submit this Referral Registration Form, when they wish to refer any interested person to buy a property in any Puravankara Projects.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              3. Existing owners who approach the Company through Brokers, Real Estate Agents and Channel Partners of Puravankara are not eligible to participate in this scheme.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              4. Any referral registered by an existing owner will be valid for only 90 days and shall lapse unless extended by the company, or upon receipt of an extension from by the referrer/ applicant. Any sale closed, thereafter is not entitled to any referral benefit.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              5. Once a referral is registered with complete details of the interested person, the sales team shall do the needful in converting the sale and update the status to the referrer. The referrer is eligible for referral benefit only after Agreement for Sale and Construction Agreement are executed by such customer along with payment of 15% of the sale value. 15% payment for ongoing and ready to move in projects.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              6. The referral benefit shall be restricted to 2% (1% to referrer and 1% to referee) of the Basic Cost of the apartment excluding taxes and other charges, in the form of Privilege Points. The Privilege points shall be credited within 45 days, post 15% of payment towards the unit. For self-purchase, up-to 2 % of the Basic Cost of the unit excluding taxes and other charges, will be paid in the form of Privilege points. The referral points so credited to the referee's Purva Privilege account can be redeemed through Purva Privilege website (www.purvaprivilege.com)
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              7. The disputes arising out of this policy between the applicant and the sales team shall be referred to arbitration by the Head of Customer Experience & Loyalty Sales whose decision shall be final and binding on both parties.
              </li>
            </ol>
          </div>
        ) : null}

        {primarySource === PRIMARY_SOURCE?.ProvidentPremiere ? (
          <div className="referralProgramTerms">
            <ol className="ListNumber">
              <li>
                <b className="liB">REFERRAL PROGRAM</b>
              </li>
            </ol>

            <ol className="ListNumber">
              <li>
                1. Provident Premier is a program offered by Provident Housing Limited exclusively to existing and ex-property owners of
                   Provident Housing Limited (“Referrer”), during the currency of this programme.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              2. Referrers are required to submit a Referral Registration Form, as soon as their referred family or friend buy
                  Flat/condos/villa/plots property in any Provident Housing Limited.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              3. Referrers who approach the Company through Brokers, Real Estate Agents and Channel Partners of Provident Housing
                  Limited / Puravankara are not eligible to participate in this scheme.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              4. Any referral registered by the Referrer on the portal (Providentpremier.com) will be valid for only 90 days for that referral
                  and shall lapse unless extended by the company, or upon receipt of an extension form by the referrer / applicant. In case
                  the sale is not concluded within 90 days or such extended time, the Referrer will not be entitled to any Referral Rewards.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              5. As soon as a referral is registered on the portal (providentpremir.com) with complete details of person interested in
                  purchasing an apartment, the Cognizant Office shall do the needful in converting the sale and shall update the status to
                  the Referrer. The Referrer is eligible for referral rewards in the form of points only after Agreement for Sale and Construction
                  Agreement are executed by such customer along with 15% of the sale value.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              6. The Referral Rewards shall be restricted to 2% of the Basic Cost of the apartment (taxes and other charges excluded)
                  which is equally distributed between Referrer & Referee. For repeat Purchase up-to 2% of Basic Cost of the apartment/
                  plot as Reward Points which can be utilised in the manner provided above.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              7. Rewards are provided in the form of Points – 1 Point is equivalent to1 rupees – Subject to change without notice.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              8. Any disputes that may arise in relation to this policy the matter shall be referred to arbitration by the Director, Sales and
                  Marketing of Provident Housing Limited, whose decision shall be final and binding on the Referrer.
              </li>
            </ol>
            <ol className="ListNumber">
              <li>
              9. The Reward payable shall stand adjusted against any outstanding amount payable under any head to Provident /
                  Puravankara. Balance amount if any payable post such adjustment will be adjusted against future demands that will be
                  raised by Puravankara/ Provident.
              </li>
            </ol>
          </div>
        ) : null}

         <div className="dashedBorder"></div> 

        <div className={`declarationWrap`}>
        <ol className="ListNumber">
          <li>
            <b className="liB">Declaration</b>
          </li>
        </ol>
          <p>
            I/ We, the Applicant(s), declare our understanding / satisfaction on
            the following:
          </p>
          <p>
            1. The details pertaining to the project viz; location,
            specification, amenities, project and apartment layout, sanction
            plans, payment and completion schedule etc have been explained by
            the Promoter and are satisfied of information provided during visit
            to the project site / website of the Promoter and RERA
          </p>
          <p>
            2. That all communications (majorly electronic mode) shall be sent
            to the email id / communication address of the first applicant.
          </p>
          <p>
            3. That I / We, the Applicant(s) shall be solely responsible for
            updating any change in communication address / personal details to
            the Promoter, failing which any communication or information based
            on the details furnished in the Application shall be deemed to have
            been received by the Applicant(s) or shall be deemed valid.
          </p>
          <p>
            4. The deposits, charges, taxes and levies payable to government
            agencies, as applicable from time to time shall be borne by me /us
          </p>
          <p>
            5. The parking spaces will be marked and allotted after the
            completion of the project
          </p>
          <p>
            6. In case I/ We, the Applicant(s), is/are desirous of
            changing/substituting the names of purchasers/applicants after the
            execution and registration of the agreement to sell, all charges,
            costs and expenses associated therewith, including but not limited
            to procuring, embossing, franking of relevant document and purchase
            of stamp papers shall be borne exclusively by the applicant(s).
          </p>
          <p>
            7. That if the the provisional Allotment is cancelled in accordance
            with the Terms contained herein, promoter is entitled to Allot the
            cancelled unit to any third party at its sole discretion. I/ we ,
            the Applicants, will thereafter have no further rights or claims
            against the company / promoter for Allotment / Possession of the
            cancelled unit.
          </p>
          <p>
            8. I/ We, the applicant(s), are solely responsible for the payment
            of TDS, as applicable for this transaction
          </p>
          <p>
            I/We have read the above terms and conditions of this Application
            and accept that the same shall be applicable on me/us, our legal
            heirs and successors. I/we fully understood the contents thereof,
            have obtained legal advice on the same, and I/we expressly agree to
            strictly abide by and adhere to these terms and conditions.
          </p>
        </div>


        {!isPreview ? (
         <TAConditionCTA handlePrevious={handlePrevious}/>
        ) : null}
      </div>
  );
};

export default TAConditionPuravankaraLandProjects;
